<div class="datiq-cell-location">
    <div
        class="datiq-cell-location__container datiq-cell-location__container--icon"
    >
        <mat-icon
            [svgIcon]="settings?.location"
            class="datiq-cell-location__icon"
        ></mat-icon>
    </div>
    <div
        class="datiq-cell-location__container datiq-cell-location__container--label"
        datiqTruncate
        (datiqTruncateEllipsed)="isTruncated = $event"
        [matTooltip]="settings?.geoInfo?.displayName"
        [matTooltipDisabled]="!isTruncated"
    >
        <span class="datiq-cell-location__label">
            {{ settings?.geoInfo?.displayName }}</span
        >
    </div>
</div>
